export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/jen-profile-3e6a59b3f0d5e340875ca39f4d6f5853.png";